<div class="approval-page">
  <!-- Loading State -->
  <div *ngIf="loading" class="approval-loading">
    <div class="spinner"></div>
    <p>Loading approval information...</p>
  </div>

  <!-- Error State -->
  <div *ngIf="!loading && error" class="approval-card error-card">
    <div class="card-icon error-icon">
      <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
        <circle cx="12" cy="12" r="10"/>
        <line x1="15" y1="9" x2="9" y2="15"/>
        <line x1="9" y1="9" x2="15" y2="15"/>
      </svg>
    </div>
    <h2>Invalid or Expired Link</h2>
    <p>{{ error }}</p>
    <p class="help-text">If you believe this is an error, please contact the RTA team for assistance.</p>
  </div>

  <!-- Approval Form -->
  <div *ngIf="!loading && !error && info && !completed" class="approval-card">
    <div class="card-header" [ngClass]="{'approve-header': !isReject, 'reject-header': isReject}">
      <h1>{{ actionLabel }} Order</h1>
      <span class="action-badge" [ngClass]="{'approve-badge': !isReject, 'reject-badge': isReject}">
        {{ info.processName }}
      </span>
    </div>

    <div class="order-summary">
      <h3>Order Summary</h3>
      <div class="summary-grid">
        <div class="summary-item">
          <label>Order ID</label>
          <span>{{ info.orderId }}</span>
        </div>
        <div class="summary-item">
          <label>Description</label>
          <span>{{ info.orderDescription || '—' }}</span>
        </div>
        <div class="summary-item">
          <label>Product Line</label>
          <span>{{ info.productLine || '—' }}</span>
        </div>
        <div class="summary-item">
          <label>Sub PSL</label>
          <span>{{ info.subPsl || '—' }}</span>
        </div>
        <div class="summary-item">
          <label>Submitted By</label>
          <span>{{ info.submittedBy || '—' }}</span>
        </div>
      </div>
    </div>

    <!-- Rejection Reason (only for reject action) -->
    <div *ngIf="isReject" class="reason-section">
      <label for="reason">Reason for Rejection <span class="required">*</span></label>
      <textarea
        id="reason"
        [(ngModel)]="reason"
        placeholder="Please provide a reason for rejecting this order..."
        rows="4"
        [class.invalid]="isReject && !reason.trim() && submitting"
      ></textarea>
      <p *ngIf="isReject && !reason.trim()" class="validation-msg">A reason is required when rejecting an order.</p>
    </div>

    <div class="action-section">
      <button
        class="btn-action"
        [ngClass]="{'btn-approve': !isReject, 'btn-reject': isReject}"
        (click)="submit()"
        [disabled]="submitting || (isReject && !reason.trim())"
      >
        <span *ngIf="!submitting">{{ actionLabel }} Order</span>
        <span *ngIf="submitting" class="btn-loading">
          <span class="spinner-small"></span>
          Processing...
        </span>
      </button>
    </div>
  </div>

  <!-- Completion State -->
  <div *ngIf="!loading && completed" class="approval-card" [ngClass]="{'success-card': resultSuccess, 'error-card': !resultSuccess}">
    <div class="card-icon" [ngClass]="{'success-icon': resultSuccess, 'error-icon': !resultSuccess}">
      <svg *ngIf="resultSuccess" xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
        <circle cx="12" cy="12" r="10"/>
        <polyline points="9 12 12 15 16 10"/>
      </svg>
      <svg *ngIf="!resultSuccess" xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
        <circle cx="12" cy="12" r="10"/>
        <line x1="15" y1="9" x2="9" y2="15"/>
        <line x1="9" y1="9" x2="15" y2="15"/>
      </svg>
    </div>
    <h2>{{ resultSuccess ? 'Action Completed' : 'Action Failed' }}</h2>
    <p>{{ resultMessage }}</p>
  </div>

  <!-- Halliburton Branding -->
  <div class="branding">
    <p>DBS DatCI — RTA Order Management</p>
  </div>
</div>
